import { ConfirmOrderCreateOrderController } from "./confirm-order-create-order.controller";
import { ORDER_SERVICE_NAME } from "../../../../../../services/order"
import { ORDER_CONFIRM_SERVICE_NAME } from "../../../../../../services/order/order.confirm.service"

//#region Asset Imports

import * as TEMPLATE from './confirm-order-create-order.tpl.html'
import './confirm-order-create-order.scss'

//#endregion

export const COMPONENT_NAME: string = 'confirmOrderCreateOrder'

export class ConfirmOrderCreateOrderComponent {

    controller = [
        ORDER_SERVICE_NAME,
        ORDER_CONFIRM_SERVICE_NAME,
        ConfirmOrderCreateOrderController]

    bindings = {
        options: '<',
    } as { [index: string]: string }

    template = TEMPLATE

}